import { ACCESS_REQUEST_TYPE, formatEnumLabel } from '../../constants/enums';
import { accessProvisionApi } from '../../api/systemRegisterApi';

const todayIsoDate = () => {
  const d = new Date();
  const yyyy = d.getFullYear();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
};

export const accessProvisionConfig = {
  mode: 'lookup',
  entityName: 'Access Administration',
  api: {
    list: (params) => accessProvisionApi.list(params),
    create: (body) => accessProvisionApi.create(body),
    update: (id, body) => accessProvisionApi.update(id, body),
    remove: (id) => accessProvisionApi.remove(id),
  },
  fields: [
    { name: 'requestDate', label: 'Request Date', type: 'date', required: true, gridSpan: 6 },
    {
      name: 'requestType',
      label: 'Request Type',
      type: 'enum',
      options: ACCESS_REQUEST_TYPE,
      required: true,
      gridSpan: 6,
    },
    {
      name: 'requestedByUserId',
      label: 'Requested By',
      type: 'lookupSelect',
      lookupKey: 'tenantUsers',
      optionLabel: 'label',
      required: true,
      gridSpan: 6,
      defaultToCurrentUser: true,
      hideOnCreate: true,
      hideOnEdit: true,
    },
    {
      name: 'reasonForRequest',
      label: 'Reason for Request',
      type: 'textarea',
      required: true,
      gridSpan: 12,
      hint: 'Business justification for the access',
    },
  ],
  columns: [
    { field: 'requestDate', headerName: 'Request Date', width: 140 },
    {
      field: 'updatedAt',
      headerName: 'Updated At',
      width: 180,
      valueFormatter: (params) => {
        if (!params.value) return '—';
        const d = new Date(params.value);
        return Number.isNaN(d.getTime()) ? String(params.value) : d.toLocaleString();
      },
    },
    {
      field: 'requestStatus',
      headerName: 'Status',
      width: 130,
      valueFormatter: (params) => formatEnumLabel(params.value) || '—',
    },
    {
      field: 'requestType',
      headerName: 'Request Type',
      flex: 1,
      minWidth: 180,
      valueFormatter: (params) => formatEnumLabel(params.value) || '—',
    },
    { field: 'requestedBy', headerName: 'Requested By', flex: 1, minWidth: 160 },
    { field: 'reasonForRequest', headerName: 'Reason for Request', flex: 1.4, minWidth: 220 },
  ],
  toPayload: (values) => ({
    requestDate: values.requestDate || todayIsoDate(),
    requestType: values.requestType,
    requestedByUserId: values.requestedByUserId || undefined,
    reasonForRequest: values.reasonForRequest?.trim(),
  }),
  formColumns: 2,
  loadTenantUsers: true,
  toRow: (item) => ({
    id: item.id,
    status: item.status || 'ACTIVE',
    ...item,
    requestedByUserId: item.requestedByUserId != null ? String(item.requestedByUserId) : '',
    requestedBy: item.requestedBy || item.requestedByEmail || '',
  }),
  getInitialValues: (row, fieldsList) => {
    const fields = fieldsList || [];
    const initial = {};
    fields.forEach((f) => {
      if (f.name === 'requestDate') {
        initial.requestDate = row?.requestDate || todayIsoDate();
        return;
      }
      if (f.name === 'requestedByUserId') {
        initial.requestedByUserId = row?.requestedByUserId != null ? String(row.requestedByUserId) : '';
        return;
      }
      initial[f.name] =
        row?.[f.name]
        ?? (f.type === 'boolean' ? false : f.type === 'multiEnum' || f.type === 'multiLookupSelect' ? [] : '');
    });
    return initial;
  },
  showView: true,
  getViewPath: (row) => `/system-register/access-provisions/view?id=${row.id}`,
  canEdit: (row) => {
    const status = String(row?.requestStatus || '').toUpperCase();
    return status !== 'APPROVED' && status !== 'COMPLETED';
  },
};
